/* eslint-disable camelcase */
import { handleActions, createAction } from 'redux-actions';

export type ScheduledChangeAction = 'cancel' | 'update' | null
export type BillingCycle = 'month' | 'year'| null
export type SubscriptionStatus = 'active' | 'canceled' | 'past_due'

export interface SubscriptionCurrentTierResponse {
  price_id: string
  status: SubscriptionStatus
  next_payment: string | null
  billing_cycle: BillingCycle
  scheduled_change_action: ScheduledChangeAction
  scheduled_change_effective_at: string | null
  requested_price_id: string | null
}

export interface PreviewSubscriptionResponse {
  currency: string
  immediate_transaction_price: string
  immediate_transaction_tax: string
  next_billed_at: string
  recurring_transaction_price : string
  recurring_transaction_tax: string
}

export interface SubscriptionManagementUrlResponse {
  update_payment_method: string
}

interface SubscriptionTierState {
  isLoading: boolean
  failed: boolean
  details: SubscriptionCurrentTierResponse | null
}

const initialState: SubscriptionTierState = {
  isLoading: true,
  failed: false,
  details: null,
};

export const getCurrentSubscriptionInitialized = createAction(
  '@platform/query/payments/currentSubscription/get/init',
);
export const getCurrentSubscriptionSucceeded = createAction(
  '@platform/query/payments/currentSubscription/get/success',
  (payload: any) => payload,
);
export const getCurrentSubscriptionFailed = createAction(
  '@platform/query/payments/currentSubscription/get/failed',
);

export const previewNewSubscriptionInitialized = createAction(
  '@platform/command/payments/previewNewSubscription/init',
);
export const previewNewSubscriptionSucceeded = createAction(
  '@platform/command/payments/previewNewSubscription/success',
  (payload: any) => payload,
);
export const previewNewSubscriptionFailed = createAction(
  '@platform/command/payments/previewNewSubscription/failed',
);

export const applyNewSubscriptionInitialized = createAction(
  '@platform/command/payments/applyNewSubscription/init',
);
export const applyNewSubscriptionSucceeded = createAction(
  '@platform/command/payments/applyNewSubscription/success',
  (payload: any) => payload,
);
export const applyNewSubscriptionFailed = createAction(
  '@platform/command/payments/applyNewSubscription/failed',
);

export const cancelCurrentSubscriptionInitialized = createAction(
  '@platform/command/payments/cancelCurrentSubscription/init',
);
export const cancelCurrentSubscriptionSucceeded = createAction(
  '@platform/command/payments/cancelCurrentSubscription/success',
);
export const cancelCurrentSubscriptionFailed = createAction(
  '@platform/command/payments/cancelCurrentSubscription/failed',
);


export default handleActions<SubscriptionTierState, SubscriptionCurrentTierResponse>({
  [getCurrentSubscriptionInitialized.toString()]: state => ({
    ...initialState,
    details: state.details ?? initialState.details,
  }),
  [getCurrentSubscriptionSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    isLoading: false,
    failed: false,
    details: payload,
  }),
  [getCurrentSubscriptionFailed.toString()]: state => ({
    ...state,
    isLoading: false,
    failed: true,
  }),
}, initialState);
